import React from 'react'
import { Modal } from '@web/walter-ui-kit'
import { GetCard } from '@web/walter-lib/api'
import Content from '~pages/CardsPage/Cards/Freeze/FreezeModal/Content'

interface Props {
    isOpen: boolean
    onClose: () => void
    card?: GetCard
}

function FreezeModal({ isOpen, onClose, card }: Props) {
    return (
        <Modal
            type="dialog"
            withHeaderBorder={false}
            onClose={onClose}
            isOpen={isOpen}
            dataPointer="freeze_modal"
            size="xs"
        >
            <Content onClose={onClose} card={card} />
        </Modal>
    )
}

export default FreezeModal
